<template>
  <div class="stillvorbereitung">
    <h1>Stillvorbereitungskurs in Koblenz & Online</h1>
    <p>Die Zeit vor der Geburt ist voller Veränderungen – körperlich, emotional und organisatorisch. Zwischen Geburtsvorbereitung, Kliniktasche packen und Baby-Erstausstattung bleibt das Thema Stillen oft im Hintergrund. Dabei ist genau jetzt der richtige Moment, um sich auch auf die Stillzeit vorzubereiten.</p>
    <p>Denn viele Stillprobleme entstehen durch Unsicherheit und fehlendes Wissen – gerade wenn in den ersten Tagen viele Meinungen und Tipps auf einen einprasseln. Mit einer guten Vorbereitung kannst du genau das vermeiden. Du stärkst das Vertrauen in dich und deinen Körper und bekommst realistische Erwartungen an die erste Zeit nach der Geburt.</p>
    <p>Ein Stillvorbereitungskurs bietet dir die Möglichkeit, dich ganz bewusst mit dem Thema auseinanderzusetzen – <i>ohne Druck, ohne Stress, mit viel Raum für Fragen</i>. Du erfährst, wie du dein Baby richtig anlegst, welche Stillpositionen euch den Start erleichtern können und wie Milchbildung eigentlich funktioniert. Auch mögliche Anfangsschwierigkeiten und wie du damit umgehen kannst, sind Teil meines Kurses.</p>
    <p>Wenn du selbstsicher in die Stillzeit starten willst oder noch gar nicht entschieden hast, ob du Stillen möchtest und einfach Informationen suchst, dann ist ein Stillvorbereitungskurs genau das richtige für dich!</p>
    <h2>Du darfst dich auf folgende Themen freuen:</h2>
    <ul>
      <li>Wie funtionieren Stillen und Milchbildung?</li>
      <li>Vorteile des Stillens</li>
      <li>Der "perfekte" Stillstart</li>
      <li>Stillpositionen & korrektes Anlegen</li>
      <li>Stilldauer und -häufigkeit, was ist normal?</li>
      <li>Die häufigsten Stillprobleme</li>
      <li>Erste Hilfe bei wunden Brustwarzen</li>
      <li>Aufklärung über Stillmythen</li>
    </ul>
    <p>Selbstverständlich haben wir am Ende auch Zeit für all deine Fragen. Bitte habe jedoch Verständnis, dass eine individuelle <router-link to="/stillberatung">Stillberatung</router-link> aufgrund der begrenzten Zeit nicht möglich ist.</p>
    <p>Kurse finden online oder vor Ort in Metternich statt. Schau dazu einfach bei den <router-link to="/">aktuellen Terminen</router-link> nach.</p>
    <p>Infos zu <strong>Preisen und Ablauf</strong> findet ihr <router-link to="/preise">hier</router-link>.</p>
  </div>
</template>

<script>
export default {
  name: 'Stillvorbereitung'
}
</script>

<style scoped>
.stillvorbereitung {
}
</style>